import React from 'react';

const PrintIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.04297 5.83073H13.9596V4.16406C13.9596 2.4974 13.3346 1.66406 11.4596 1.66406H8.54297C6.66797 1.66406 6.04297 2.4974 6.04297 4.16406V5.83073Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3346 12.5V15.8333C13.3346 17.5 12.5013 18.3333 10.8346 18.3333H9.16797C7.5013 18.3333 6.66797 17.5 6.66797 15.8333V12.5H13.3346Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 8.33594V12.5026C17.5 14.1693 16.6667 15.0026 15 15.0026H13.3333V12.5026H6.66667V15.0026H5C3.33333 15.0026 2.5 14.1693 2.5 12.5026V8.33594C2.5 6.66927 3.33333 5.83594 5 5.83594H15C16.6667 5.83594 17.5 6.66927 17.5 8.33594Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1654 12.5H13.157H5.83203"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83203 9.16406H8.33203"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PrintIcon;
